import { createAction } from '@reduxjs/toolkit';

/**
 * @todo refactor: { payload: isLoading }, not payload: { isLoading: isLoading}
 */
export const showHideLoader = createAction('loader/showHideLoader', function prepare(isLoading) {
  return {
    payload: {
      isLoading
    }
  };
});
